/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else {
          // 每次打开首页都显示弹窗（不再检查 cookie）
          this.open();

          // 如果仍想保留原来的触发条件（延迟 / 离开页面等），可取消下面注释
          // if (this.querySelector('.alert')) {
          //   this.open();
          // } else if (this.dataset.trigger === 'delay') {
          //   setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          // } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
          //   this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
          //   document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          // }
        }
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        // 不再检查 cookie，只要鼠标离开顶部就打开
        if (evt.clientY < 0) this.open();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        // 不再写入 cookie，这样下次进入首页仍会显示
      }
    }

    customElements.define('pop-up', PopUp);
  });
}